// --- API Hooks ---
import {
  useGetUserProfileQuery,
  useAuthenticateUserMutation,
  useLogoutUserMutation,
  useUpdateUserProfileMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation,
} from "../templates/user/api/userAuthApi";

// --- Custom Business Logic Hooks ---
import { useUserAuth } from "../templates/user/hooks/useUserAuth";
import { useUserLogout } from "../templates/user/hooks/useUserLogout";
import { useUpdateProfile } from "../templates/user/hooks/useUpdateProfile";
import { useProfileAddressUpdate } from "../templates/user/hooks/useProfileAddressUpdate";
import { useForgotPassword } from "../templates/user/hooks/useForgotPassword";
import { useResetPassword } from "../templates/user/hooks/useResetPassword";

// --- Validation Schemas (Highly useful for custom forms) ---
import {
  createLoginSchema,
  createRegisterSchema,
  createAccountDetailsSchema,
  createForgotPasswordSchema,
  createResetPasswordSchema,
} from "../templates/user/helpers/userValidation";

// --- Redux Actions ---
import { setActiveTab } from "../templates/user/userSlice";

// --- Reusable UI Components ---
import PasswordRequirements from "../templates/user/components/common/PasswordRequirements";

export const user = {
  // 1. API Data Fetching (Direct RTK Query)
  api: {
    useGetUserProfileQuery,
    useAuthenticateUserMutation,
    useLogoutUserMutation,
    useUpdateUserProfileMutation,
    useForgotPasswordMutation,
    useResetPasswordMutation,
  },

  // 2. Custom Logic Hooks (Wraps API calls with Toast feedback & redirects)
  hooks: {
    useUserAuth,
    useUserLogout,
    useUpdateProfile,
    useProfileAddressUpdate,
    useForgotPassword,
    useResetPassword,
  },

  // 3. Validation
  // Exporting the Zod schema generators so custom theme forms
  // maintain the exact same security/validation rules as the core plugin.
  validation: {
    createLoginSchema,
    createRegisterSchema,
    createAccountDetailsSchema,
    createForgotPasswordSchema,
    createResetPasswordSchema,
  },

  // 4. Redux Actions
  actions: {
    ui: {
      setActiveTab,
    },
  },

  // 5. Reusable Components
  components: {
    PasswordRequirements,
  },
};
